// =============================================================
// MOTION TOKENS — typed motion budget (mimari plan)
// =============================================================

export const DUR = {
  instant: 80,
  fast:    160,
  normal:  280,
  slow:    480,
  hero:    900,
} as const;

export const EASE = {
  out:    "power2.out",
  in:     "power2.in",
  inOut:  "power2.inOut",
  premium: "power3.out",
  spring: "back.out(1.7)",
  expo:   "expo.out",
} as const;

export const STAGGER = {
  micro:    0.02,
  standard: 0.06,
  bold:     0.12,
  wave:     0.04,
} as const;

export const DIST = {
  subtle: 12,
  normal: 24,
  bold:   48,
  hero:   96,
} as const;